// components/project-details/ProjectManagement.js
import React from 'react';
import FileUploader from './FileUploader';
import ImageGallery from './ImageGallery';
import styles from './ProjectDetails.module.css';

const ProjectManagement = ({ project, onFileUpload, uploading, invoices, onImagesUpdate }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-l)' }}>
      <h2 className={styles.sectionTitle}>Project Management</h2>
      
      {/* Product Images Section */}
      <div>
        <h3 style={{ 
          fontSize: 'var(--font-size-subtitle3)', 
          fontWeight: 'var(--font-weight-subtitle3)',
          color: 'var(--Text-Primary)',
          marginBottom: 'var(--spacing-s)'
        }}>
          Product Images
        </h3>
        <FileUploader onFileUpload={onFileUpload} uploading={uploading} />
        
        {project.productImages && project.productImages.length > 0 && (
          <ImageGallery 
            images={project.productImages} 
            projectId={project.id}
            onImagesUpdate={onImagesUpdate}
          />
        )}
      </div>

      {/* Invoices Section */}
      {invoices && invoices.length > 0 && (
        <div>
          <h3 style={{ 
            fontSize: 'var(--font-size-subtitle3)', 
            fontWeight: 'var(--font-weight-subtitle3)',
            color: 'var(--Text-Primary)',
            marginBottom: 'var(--spacing-s)'
          }}>
            Project Invoices
          </h3>
          <div className={styles.sectionCard}>
            <div className={styles.invoiceList}>
              {invoices.map((invoice) => (
                <div key={invoice.id} className={styles.invoiceItem}>
                  <div className={styles.invoiceInfo}>
                    <div className={styles.invoiceNumber}>
                      Invoice #{invoice.invoiceNumber || invoice.id.slice(-6)}
                    </div>
                    <div className={styles.invoiceAmount}>
                      £{invoice.total?.toFixed(2) || '0.00'}
                    </div>
                  </div>
                  <div className={styles.invoiceActions}>
                    <span className={`${styles.invoiceStatus} ${styles[invoice.status]}`}>
                      {invoice.status}
                    </span>
                    <a
                      href={`/invoices/${invoice.id}`}
                      className={styles.viewLink}
                    >
                      View
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Project Timeline */}
      <div>
        <h3 style={{ 
          fontSize: 'var(--font-size-subtitle3)', 
          fontWeight: 'var(--font-weight-subtitle3)',
          color: 'var(--Text-Primary)',
          marginBottom: 'var(--spacing-s)'
        }}>
          Project Timeline
        </h3>
        <div className={styles.sectionCard}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-s)' }}>
            {project.stage?.enquiryDate && (
              <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--spacing-s)' }}>
                <div style={{ 
                  width: '0.5rem', 
                  height: '0.5rem', 
                  backgroundColor: 'var(--Amber-500)', 
                  borderRadius: 'var(--radius-pill)' 
                }}></div>
                <div style={{ fontSize: 'var(--font-size-body4)' }}>
                  <span style={{ fontWeight: 'var(--font-weight-medium)' }}>Enquiry received:</span>{' '}
                  {new Date(project.stage.enquiryDate.seconds * 1000).toLocaleDateString()}
                </div>
              </div>
            )}
            {project.stage?.projectStartedDate && (
              <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--spacing-s)' }}>
                <div style={{ 
                  width: '0.5rem', 
                  height: '0.5rem', 
                  backgroundColor: 'var(--Green-500)', 
                  borderRadius: 'var(--radius-pill)' 
                }}></div>
                <div style={{ fontSize: 'var(--font-size-body4)' }}>
                  <span style={{ fontWeight: 'var(--font-weight-medium)' }}>Project started:</span>{' '}
                  {new Date(project.stage.projectStartedDate.seconds * 1000).toLocaleDateString()}
                </div>
              </div>
            )}
            {project.stage?.completedDate && (
              <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--spacing-s)' }}>
                <div style={{ 
                  width: '0.5rem', 
                  height: '0.5rem', 
                  backgroundColor: 'var(--Purple-500)', 
                  borderRadius: 'var(--radius-pill)' 
                }}></div>
                <div style={{ fontSize: 'var(--font-size-body4)' }}>
                  <span style={{ fontWeight: 'var(--font-weight-medium)' }}>Project completed:</span>{' '}
                  {new Date(project.stage.completedDate.seconds * 1000).toLocaleDateString()}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectManagement;
